// extracted by mini-css-extract-plugin
export default {"frameFooter":"FrameFooter_frameFooter__aZbd6"};